import { createPluginFactory } from '@udecode/plate';
import { BufferEditor, BufferValue } from '~/editor/BufferEditor/types.plate';
import { BufferPluginOptions } from '../types';
import { ParagraphElement } from './nodes/ParagraphElement';
import { withParagraph } from './withParagraph';

export const createParagraphPlugin = createPluginFactory<
  BufferPluginOptions,
  BufferValue,
  BufferEditor
>({
  key: ParagraphElement.type,
  isElement: true,
  withOverrides: withParagraph,
});
